import React, { useState, useEffect } from 'react';
import { ChevronUp, Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

interface FloatingCTAProps {
  show: boolean;
}

export const FloatingCTA: React.FC<FloatingCTAProps> = ({ show }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 200;
      setIsVisible(scrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <button
      onClick={() => {
        // Scroll to top and focus on invite code input
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => {
          const inviteInput = document.querySelector('input[placeholder="Enter your invite code"]') as HTMLInputElement;
          if (inviteInput) inviteInput.focus();
        }, 800);
      }}
      className={cn(
        "fixed bottom-24 right-8 bg-gold-400 p-3 rounded-full shadow-lg hover:bg-gold-500 transition-all duration-300",
        "transform translate-y-2 z-[9999] border border-gold-300/30",
        "flex items-center gap-2 px-5 py-4",
        isVisible && show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10 pointer-events-none"
      )}
    >
      <Sparkles className="w-6 h-6" />
      <span className="font-medium text-base">New member with invite?</span>
      <ChevronUp className="w-6 h-6" />
    </button>
  );
};